import { AceTag } from '../AceTag';
import { InsuranceEligibilityStatus } from '@axo/shared/data-access/types/insurance';
import { Tag } from '@blueprintjs/core';

export function InsuranceEligibilityStatusTag({
  status,
}: {
  status?: InsuranceEligibilityStatus | string;
}) {
  if (!status) {
    return null;
  }

  switch (status) {
    case InsuranceEligibilityStatus.APPROVED:
      return (
        <Tag minimal round intent="primary">
          ELIGIBLE
        </Tag>
      );
    case InsuranceEligibilityStatus.NEW:
      return (
        <Tag minimal round intent="success">
          NEW
        </Tag>
      );
    case InsuranceEligibilityStatus.DENIED:
      return (
        <Tag minimal round intent="danger">
          NOT ELIGIBLE
        </Tag>
      );
    default:
      return <AceTag>{(status as string).toUpperCase()}</AceTag>;
  }
}
